export default __webpack_public_path__ + "vietnam-map-800-4c86d3c4d4e1af55731f4ef0c4d88dd8.png";